<div role="region">
    <h3 class="e-your-selections-heading">Your selections</h3>

    <ng-template #noSelectionsMade>
        <p class="e-no-selections-made">No selections have been made</p>
    </ng-template>

    <!-- Temporary Selections -->
    <ng-template #showTempCountries>
        <ul>
            <li *ngFor="let country of temporarySelections.countries">{{ country.name }}</li>
        </ul>
    </ng-template>
    <ng-template #showTempCategories>
        <ul>
            <ng-container *ngFor="let category of temporarySelections.categories">
                <li>
                    {{ category.name }}<br />
                    <span class="e-category-breadcrumb" title="{{ category.breadcrumb }}">{{ category.breadcrumb }}</span>
                </li>
            </ng-container>
        </ul>
    </ng-template>
    <ng-template #showTempSuppliers>
        <ul>
            <li *ngFor="let supplier of temporarySelections.suppliers">{{ supplier.name }}</li>
        </ul>
    </ng-template>
    <ng-template #showTempBrands>
        <ul>
            <ng-container *ngFor="let brand of temporarySelections.brands">
                <li>
                    {{ brand.brandName }}
                    <ng-container *ngFor="let subBrand of brand.subBrands">
                        <li>
                            <span class="e-brand-sub-brand" title="{{ subBrand.subBrandName }}">{{ subBrand.subBrandName }}</span>
                        </li>
                    </ng-container>
                </li>
            </ng-container>
        </ul>
    </ng-template>
    <ng-template #showTempAttributeTypes>
        <ul>
            <li *ngFor="let attributeType of temporarySelections.attributeTypes">{{ attributeType.name }}</li>
        </ul>
    </ng-template>
    <ng-template #showTempAttributes>
        <ul>
            <li *ngFor="let attribute of temporarySelections.attributes">{{ attribute.value }}</li>
        </ul>
    </ng-template>
    <ng-template #showTempRetailerTypes>
        <ul>
            <li *ngFor="let retailerType of temporarySelections.retailerTypes">{{ retailerType.name }}</li>
        </ul>
    </ng-template>
    <ng-template #showTempRetailers>
        <ul>
            <li *ngFor="let retailer of temporarySelections.retailers">{{ retailer.name }}</li>
        </ul>
    </ng-template>
    <ng-template #showTempPromotions>
        <ul>
            <li *ngFor="let promotion of temporarySelections.promotions">{{ promotion.name }}</li>
        </ul>
    </ng-template>

    <div class="e-your-selections">
        <mat-accordion displayMode="flat" multi *ngIf="selectionsMade(); else noSelectionsMade">
            <mat-expansion-panel
                *ngIf="selections.countries?.length || temporarySelections.countries?.length"
                [expanded]="currentTab === 1">
                <mat-expansion-panel-header>
                    <mat-panel-title>Countries</mat-panel-title>
                </mat-expansion-panel-header>
                <ul *ngIf="selections.countries?.length; else showTempCountries">
                    <li *ngFor="let country of selections.countries">{{ country.name }}</li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="selections.categories?.length || temporarySelections.categories?.length"
                [expanded]="currentTab === 2">
                <mat-expansion-panel-header tabindex="-1">
                    <mat-panel-title>Categories</mat-panel-title>
                </mat-expansion-panel-header>
                <ul *ngIf="selections.categories?.length; else showTempCategories">
                    <ng-container *ngFor="let category of selectedCategories">
                        <li>
                            {{ category.name }}<br />
                            <span class="e-category-breadcrumb" title="{{ category.breadcrumb }}">{{ category.breadcrumb }}</span>
                        </li>
                    </ng-container>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="selections.suppliers?.length || temporarySelections.suppliers?.length"
                [expanded]="currentTab === 3">
                <mat-expansion-panel-header tabindex="-1">
                    <mat-panel-title>Suppliers</mat-panel-title>
                </mat-expansion-panel-header>
                <ul *ngIf="selections.suppliers?.length; else showTempSuppliers">
                    <li *ngFor="let supplier of selections.suppliers">{{ supplier.name }}</li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="selections.brands?.length || temporarySelections.brands?.length" [expanded]="currentTab === 4">
                <mat-expansion-panel-header tabindex="-1">
                    <mat-panel-title>Brands</mat-panel-title>
                </mat-expansion-panel-header>
                <ul *ngIf="selections.brands?.length; else showTempBrands">
                    <ng-container *ngFor="let brand of selections.brands">
                        <li>
                            {{ brand.brandName }}
                            <ng-container *ngFor="let subBrand of brand.subBrands">
                                <li>
                                    <span class="e-brand-sub-brand" title="{{ subBrand.subBrandName }}">{{ subBrand.subBrandName }}</span>
                                </li>
                            </ng-container>
                        </li>
                    </ng-container>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="selections.attributeTypes?.length || temporarySelections.attributeTypes?.length"
                [expanded]="currentTab === 5">
                <mat-expansion-panel-header tabindex="-1">
                    <mat-panel-title>Attribute Types</mat-panel-title>
                </mat-expansion-panel-header>
                <ul *ngIf="selections.attributeTypes?.length; else showTempAttributeTypes">
                    <li *ngFor="let attributeType of selections.attributeTypes">{{ attributeType.name }}</li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="selections.attributes?.length || temporarySelections.attributes?.length"
                [expanded]="currentTab === 6">
                <mat-expansion-panel-header tabindex="-1">
                    <mat-panel-title>Attributes</mat-panel-title>
                </mat-expansion-panel-header>
                <ul *ngIf="selections.attributes?.length; else showTempAttributes">
                    <li *ngFor="let attribute of selections.attributes">{{ attribute.value }}</li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="selections.retailerTypes?.length || temporarySelections.retailerTypes?.length"
                [expanded]="currentTab === 7">
                <mat-expansion-panel-header tabindex="-1">
                    <mat-panel-title>Retailer Types</mat-panel-title>
                </mat-expansion-panel-header>
                <ul *ngIf="selections.retailerTypes?.length; else showTempRetailerTypes">
                    <li *ngFor="let retailerType of selections.retailerTypes">{{ retailerType.name }}</li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="selections.retailers?.length || temporarySelections.retailers?.length"
                [expanded]="currentTab === 8">
                <mat-expansion-panel-header tabindex="-1">
                    <mat-panel-title>Retailers</mat-panel-title>
                </mat-expansion-panel-header>
                <ul *ngIf="selections.retailers?.length; else showTempRetailers">
                    <li *ngFor="let retailer of selections.retailers">{{ retailer.name }}</li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="selections.promotions?.length || temporarySelections.promotions?.length"
                [expanded]="currentTab === 10">
                <mat-expansion-panel-header>
                    <mat-panel-title>Promotions</mat-panel-title>
                </mat-expansion-panel-header>
                <ul *ngIf="selections.promotions?.length; else showTempPromotions">
                    <li *ngFor="let promotion of selections.promotions">{{ promotion.name }}</li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="selections.dateRange" [expanded]="currentTab === 9">
                <mat-expansion-panel-header>
                    <mat-panel-title>Date Range</mat-panel-title>
                </mat-expansion-panel-header>
                <ul>
                    <li>{{ selections.dateRange?.startDate | date:'dd/MM/yyyy' }} - {{ selections.dateRange?.endDate | date:'dd/MM/yyyy' }}</li>
                </ul>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
